import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "drawer-header" }
const _hoisted_2 = { class: "title-main" }
const _hoisted_3 = { class: "title-warning" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { style: {"color":"#f56c6c"} }, "（ ", -1)
const _hoisted_5 = { style: {"color":"#f56c6c"} }
const _hoisted_6 = { style: {"color":"#f56c6c"} }
const _hoisted_7 = { style: {"color":"#f56c6c"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { style: {"color":"#f56c6c"} }, " ） ", -1)

import { ref, computed, watch, Ref } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'
import { applyProfitsharingWithdraw } from '@/api/operation'
import { ElMessage, ElMessageBox } from 'element-plus'
import InputWithUnit from '@/components/InputWithUnit.vue'
import FormRulesFactory from '@/common/formRules'


import { defineComponent, nextTick } from 'vue'

const __default__ = defineComponent({
  name: 'WithdrawsApply',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  info: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ['update:modelValue', 'submit', 'submitted'],
  setup(__props, { expose, emit }) {

const props = __props

const activityFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['amount'], 'inputEmpty', 'inputInvalid'),
})

const { t, tl } = useI18nTl('Operation')



let subsForm = ref()
const clearValidate = () => {
  console.log('clearValidate')
  nextTick(() => {
    let t = setTimeout(() => {
      clearTimeout(t)
      subsForm.value?.clearValidate()
    })
  })
}

const record = ref<Record<string, any>>({
  amount: 0.0,
})
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
    if (!val) {
      subsForm.value?.clearValidate()
      record.value = { amount: 0.0 }
    }
  },
})

const submit = async () => {
  await subsForm.value?.validate()

  if (record.value.amount < props.info.payee.minWithdrawAmount) {
    ElMessage.warning(t('Order.minWithdrawAmount') + `: ${props.info.payee.minWithdrawAmount}`)
    return
  }

  if (record.value.amount > props.info.wallet.balance) {
    ElMessage.warning(t('Base.balance') + `: ${props.info.wallet.balance}`)
    return
  }

  applyProfitsharingWithdraw({
    walletId: record.value.wallet.id,
    amount: record.value.amount,
  }).then((res: any) => {
    ElMessage.success(t(`Base.opSuccess`))
    showDialog.value = false
    emit('submitted')
  })
}

watch(
  () => props.modelValue,
  (val) => {
    record.value = props.info
    record.value.amount = 0.0
  },
  { immediate: true },
)
expose({
  clearValidate,
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "50%",
    class: "upsert-dialog",
    "z-index": 2000
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(record.value.payee.payeeName) + " - " + _toDisplayString(_unref(t)('Order.withdrawApply')), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('Order.withdrawApplyDesc')), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (showDialog.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        disabled: !_ctx.$hasPermission('post'),
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.apply')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        "label-position": "top",
        "require-asterisk-position": "right",
        model: record.value,
        "validate-on-rule-change": false,
        ref_key: "subsForm",
        ref: subsForm,
        rules: activityFormRule.value
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('bankCardName'),
                    prop: "bankCardName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.payee.bankCardName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((record.value.payee.bankCardName) = $event)),
                        disabled: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 12 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: _unref(tl)('bankCard'),
                    prop: "bankCard"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: record.value.payee.bankCard,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((record.value.payee.bankCard) = $event)),
                        disabled: true
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "amount",
                    required: ""
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Order.withdrawAmount')), 1),
                      _hoisted_4,
                      _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)('Base.balance')) + ": " + _toDisplayString(__props.info.wallet.balance) + " / ", 1),
                      _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(t)('Order.minWithdrawAmount')) + ": " + _toDisplayString(__props.info.payee.minWithdrawAmount) + " / ", 1),
                      _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)('Order.withdrawFee')) + ": " + _toDisplayString(__props.info.payee.withdrawFee), 1),
                      _hoisted_8
                    ]),
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: record.value.amount,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((record.value.amount) = $event)),
                        disabledUnit: true,
                        units: [{ label: '', value: '' }]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})